/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Destination } from 'reactApp/ui/DataListItemCommonComponents/Destination/Destination';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Favorite } from 'reactApp/ui/DataListItemCommonComponents/Favorite/Favorite';
import { Publish } from 'reactApp/ui/DataListItemCommonComponents/Publish/Publish';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { GalleryItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface GalleryProps extends GalleryItemProps {
    checkboxClassname?: string;
    favoriteClassname?: string;
}

export const Gallery: FC<GalleryProps> = (props) => {
    const path = props.home === '/' ? 'Облако' : props.home.slice(0, props.home.length);

    return (
        <>
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={props.checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                />
                <Pic isFolder={false} thumbUrl={props.thumbUrl} isVirus={!!props.isVirus} ext={props.ext || ''} isPublic={props.isPublic} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} id={props.id} isRenameAvailable={props.renameAvailable} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <Destination destination={path} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Favorite
                    className={props.favoriteClassname}
                    isAvailable={!!props.favoritesAvailable}
                    isFavorite={!!props.isInFavorites}
                    onClick={props.onFavorites}
                    viewType={EViewMode.list}
                />
                <Publish viewType={EViewMode.list} onClick={props.onPublish} isShared={props.isPublic} />
                <Download
                    onClick={props.onDownload}
                    ext={props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                    viewType={EViewMode.list}
                />
            </TableColumn>
        </>
    );
};
